<template>

  <div class="w100 pl20 pr20 pt20 pb20 advice-main" v-loading="loading">
    <el-tabs v-model="activeName" >
      <el-tab-pane label="建议" name="advices">

        <div class="search-warp">
          <el-form :inline="true" label-width="80px"class="">
            <el-form-item label="状态" >
              <el-radio-group v-model="paramSearch.status">
                <el-radio v-for="item in statusList"
                          :key="item.value"
                          :label="item.value"
                          >{{item.name}}

                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="建议类型" >
              <el-select v-model="paramSearch.type"
                         clearable
                         @change="getAdviceType"
                         placeholder="请选择建议类型" class="w100">
                <el-option
                        v-for="item in typeList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="部门"
                          v-if="paramSearch.type == 1">
              <TreeSelect size="small"
                          :data="departmentData"
                          clearable
                          width="300px"
                          collapseTags
                          expandAll
                          :obj="mapKey"
                          checkStrictly
                          @getValue="setDeptSingleMenuAdvice"></TreeSelect>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchFn">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="table-con">
          <el-table class="w100 mt20 table" header-row-class-name="table-head"
                    row-class-name="cu-p" stripe :data="list" >
            <el-table-column align="center"  width="200px" prop="content" label="咨询建议">
              <template slot-scope="scope">
               <span v-text="scope.row.content" class="ellipsis"></span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="type" label="类型">
              <template slot-scope="scope">
                <span  v-if="scope.row.type == 0">网站建议</span>
                <span   v-if="scope.row.type == 1">部门建议</span>
                <span  v-if="scope.row.type == 2">纠错</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="deptName" label="所涉部门"></el-table-column>
            <el-table-column align="center" prop="adviceTime" width="150px" label="建议时间">
            </el-table-column>
            <el-table-column align="center" prop="answer"  label="回复内容">
              <template slot-scope="scope">
                <span v-text="scope.row.answer" class="ellipsis"></span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="answerTime" label="回复时间" width="150px"></el-table-column>
            <el-table-column align="center" prop="answerTime" label="状态">
              <template slot-scope="scope">
                <el-tag type="success" size="small" v-if="scope.row.status == 1">已处理</el-tag>
                <el-tag type="danger" size="small"  v-if="scope.row.status == 0">未处理</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" width="200px" prop="refuseIP" label="操作">
              <template slot-scope="scope">
                <div class="to-use">
                  <span class="info" @click="getAdviceDetail(scope.row.id,scope.row.type,scope.row.status,scope.row.attachUrl)">查看详情</span>
                  <span class="info" v-if="scope.row.isAnswer&&scope.row.status == 0" @click="anSwerFn(scope.row.id)">立即回复</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="mt20 flex-box">
          <div class="flex-1"></div>
          <el-pagination background @size-change="changeSize"
                         @current-change="changePage"
                         :current-page="paramSearch.current"
                         :page-sizes="pageSizes"
                         :page-size="paramSearch.size"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"
          ></el-pagination>
        </div>


      </el-tab-pane>
      <el-tab-pane label="留言" name="leave">

        <div class="search-warp">
          <el-form :inline="true" label-width="80px"class="">
            <el-form-item label="状态" >
              <el-radio-group v-model="leaveParamSearch.status">
                <el-radio v-for="item in statusList"
                          :key="item.value"
                          :label="item.value"
                >{{item.name}}

                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="主题" >
              <by-page-select
                      ref="pageSelect"
                      :leftData="subjectList"
                      :total="subjectTotal"
                      multiple
                      collapseTags
                      title="主题选择"
                      selectWidth="width:200px"
                      :paramSearch="subjectParamSearch"
                      @handleCurrentChange="handleCurrentChange"
                      @handleSizeChange="handleSizeChange"
                      @setValue="setValue"
              >
                <el-input
                        style="margin-bottom: 4px;width: 300px"
                        slot="header"
                        placeholder="请输入主题"
                        v-model="subjectParamSearch.name"
                        @keyup.enter.native="subPage">
                </el-input>
              </by-page-select>

            </el-form-item>
            <el-form-item label="部门">
              <TreeSelect size="small"
                          :data="departmentData"
                          clearable
                          width="300px"
                          collapseTags
                          expandAll
                          :obj="mapKey"
                          checkStrictly
                          @getValue="setDeptSingleMenuLeave"></TreeSelect>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchLeaveFn">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="table-con">
          <el-table class="w100 mt20 table" header-row-class-name="table-head"
                    row-class-name="cu-p" stripe :data="leaveList" >
            <el-table-column align="center"  width="200px" label="留言">
              <template slot-scope="scope">
                <span v-text="scope.row.content" class="ellipsis"></span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="serveName" label="所涉服务"></el-table-column>
            <el-table-column align="center" prop="belongDeptName" label="涉及部门"></el-table-column>
            <el-table-column align="center" prop="createTime" width="150px" label="创建时间">
            </el-table-column>
            <el-table-column align="center"  label="回复内容">
              <template slot-scope="scope">
                <span v-text="scope.row.answer" class="ellipsis"></span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="answerTime" width="150px" label="回复时间">

            </el-table-column>
            <el-table-column align="center"   label="状态">
              <template slot-scope="scope">
                <el-tag type="success" size="small" v-if="scope.row.status == 1">已处理</el-tag>
                <el-tag type="danger" size="small"  v-if="scope.row.status == 0">未处理</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" width="200px" prop="refuseIP" label="操作">
              <template slot-scope="scope">
                <div class="to-use">
                  <span class="info" @click="getLeaveDetail(scope.row)">查看详情</span>
                  <span class="info" v-if="scope.row.isAnswer" @click="LeaveanSwerFn(scope.row)">立即回复</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="mt20 flex-box">
          <div class="flex-1"></div>
          <el-pagination background @size-change="changeSizeLeave"
                         @current-change="changePageLeave"
                         :current-page="leaveParamSearch.current"
                         :page-sizes="pageSizes"
                         :page-size="leaveParamSearch.size"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="leaveTotal"
          ></el-pagination>
        </div>


      </el-tab-pane>
    </el-tabs>

    <!-- 详情、新增 -->
    <Advice ref="Advice" @saveSuccess="saveSuccess"/>
    <!-- 详情、新增 -->
    <Leave ref="Leave" @saveSuccess="successBack" />
  </div>
</template>

<script>
import Advice from "@/components/management/advice/Advice.vue";
import Leave from "@/components/management/advice/Leave.vue";
import {
    getAdvicePage,
    getAdviceInfo,
    handleAdviceDelete,
    getServeLeaveMessagePage,
    serveLeaveMessageAddAndEdit,
    getServeLeaveMessageInfo
} from '@/api/managementCenter/advices';
import TreeSelect from "@/components/TreeSelect.vue";
import { getAdviceTypeList} from '@/api/personalCenter/suggestAngMsg';
import { getDeptTree} from '@/api/managementCenter/otherApi';
import byPageSelect from "@/components/byPageSelect.vue";
import { getSubjectList} from '@/api/managementCenter/themeManage';
export default {
  name: "Advices",
  components: {
      TreeSelect,
      Advice,
      Leave,
      byPageSelect
  },
  props: [],
  data() {
    return {
        activeName:"advices",
      loading: false,
        statusList:[
            {
                value:'',
                name:'全部'
            },
            {
                value:0,
            name:'未处理'
            },
            {
                value:1,
                name:'已处理'
            }
        ],
        typeList:[],
        departmentData:[],
        mapKey:{
            id:'id',// ID
            label: 'name',// 显示名称
            children: 'children', //子级字段名
        },
      list: [],
      leaveList:[],
      pageSizes:[10, 20, 30, 50, 100],
        paramSearch:{
            current:1,
            size:10,
            status:'',
            type:'',
            deptId:''
        },
        leaveParamSearch:{
            current:1,
            size:10,
            status:'',
            subjects:[],
            deptId:''
        },
      total: 0,
      leaveTotal: 0,
        subjectList:[],
        subjectParamSearch:{
            current:1,
            size:10,
            name:""
        },
        subjectTotal: 0,
    };
  },
  computed: {},
  created() {},
  mounted() {
      this.getListFn();
      this.getLeaveListFn();
      this.getAdviceTypeListFn();
      this.getSubjectList();
      this.getDeptTreeData();
  },
  methods: {
      getAdviceType(value){
          if(value == 1){
              this.paramSearch.deptId = ''
          }
      },
      setDeptSingleMenuAdvice(key,data){
          this.paramSearch.deptId = data.id
      },
      setDeptSingleMenuLeave(key,data){
          this.leaveParamSearch.deptId = data.id
      },
      // 获取部门数据
      getDeptTreeData(){
          getDeptTree().then(({data})=>{
              if(data.code == 0){
                  this.departmentData = data.data
              }
          }).catch(err=>{

          })

      },

      // 获取建议类型
      getAdviceTypeListFn() {
          getAdviceTypeList().then(({data})=> {
              if(data.code == 0){
                  const list = data.data || []
                  let arr = []
                  list.forEach(i=>{
                      for(let key in i){
                          arr.push({
                              name:i[key],
                              value:key
                          })
                      }
                  })
                  this.typeList =arr;
              }
          })
      },

    // 获取查询列表
    getListFn () {
        this.loading = true;
        getAdvicePage(this.paramSearch).then(({data})=> {
            this.loading = false;
           if(data.code == 0){
               this.list = data.data.records || []
               this.total = data.data.total;
           }
      })
      .catch(() => {
        this.loading = false;
      });
    },
      // 获取查询列表
      getLeaveListFn () {
          this.loading = true;
          getServeLeaveMessagePage(this.leaveParamSearch).then(({data})=> {
              this.loading = false;
              if(data.code == 0){
                  this.leaveList = data.data.records || []
                  this.leaveTotal = data.data.total;
              }
          })
              .catch(() => {
                  this.loading = false;
              });
      },
      getTypeText(value){
          let obj={
              "0":"网站建议",
              "1":"部门建议",
              "2":"纠错",
          }
          return obj[value+'']

      },
      getAdviceDetail(id,type,status,attachUrl){

          this.show=true
          getAdviceInfo(id).then(({data})=> {
              this.show=false
              if(data.code == 0){
                  this.$refs.Advice.dialogShow('detail',id,data.data||{},
                      this.getTypeText(type),status,attachUrl);
              }
          }).catch(err=>{
              this.show=false
          })
      },
      anSwerFn(id){
          this.$refs.Advice.dialogShow('answer',id);
      },


      // 默认页面数据
      searchFn() {
          this.paramSearch.current=1
          this.getListFn();
      },
      // 默认页面数据
      searchLeaveFn() {
          this.leaveParamSearch.current=1
          this.getLeaveListFn();
      },

    // 条数
    changeSize(value) {
        this.paramSearch.size=value;
        this.paramSearch.current=1;
        this.getListFn();
    },
    // 翻页
    changePage(value) {
      this.paramSearch.current=value;
      this.getListFn();
    },
    saveSuccess(){
        this.getListFn();
    },
    successBack(){
        this.getLeaveListFn ()

    },



      changeSizeLeave(value) {
          this.leaveParamSearch.size=value;
          this.leaveParamSearch.current=1;
          this.getLeaveListFn();
      },
      // 翻页
      changePageLeave(value) {
          this.leaveParamSearch.current=value;
          this.getLeaveListFn();
      },
      getLeaveDetail(item){
          this.$refs.Leave.dialogShow('detail',item);
      },
      LeaveanSwerFn(item){
          this.$refs.Leave.dialogShow('answer',item);
      },
      getSubjectList() {
          // this.$refs.pageSelect.setToading(true)
          getSubjectList(this.subjectParamSearch)
              .then(({data}) => {
                  // this.$refs.pageSelect.setToading(false)
                  if (data.code == 0) {
                      const list = data.data.records || []
                      this.subjectList = list.map(i => {
                          return {value: i.id, name: i.name}
                      })
                      this.subjectTotal = data.data.total;
                  }
              }).catch(err => {
              // this.$refs.pageSelect.setToading(false)
          })
      },
      handleCurrentChange(value) {
          this.subjectParamSearch.current = value;
          this.getSubjectList();
      },
      handleSizeChange(value) {
          this.subjectParamSearch.size = value;
          this.subjectParamSearch.current = 1;
          this.getSubjectList();
      },
      subPage() {
          this.subjectParamSearch = {
              ...this.subjectParamSearch,
              current: 1
          }
          this.getSubjectList();
      },
      setValue(data) {
          this.leaveParamSearch.subjects = data
      },


  },
  watch: {},
  filters: {}
};
</script>

<style scoped  lang="less">
  @import "../../../assets/css/handleBtn.less";
  /deep/.el-table {
    width: 100%;
    .el-table__body-wrapper {
      max-height: calc(100vh - 350px);
      overflow-y: auto;

    }
  }
  .search-warp{
    height:40px ;
  }
  /deep/.el-radio-group{
    >label{
      margin-right: 8px!important;
    }
    .el-radio__label{
      padding-left: 5px!important;
    }
  }
  /deep/.el-tabs__active-bar{
    /*background-color:#064576*/
  }
  /deep/.el-tabs__item{
    width: 80px;
    text-align: center;
    &.is-active{
      /*color:#064576 ;*/
      font-weight: bold;
    }
  }
</style>
